import styled from '@emotion/styled';
import { keyframes, css } from '@emotion/react';
import Play from '@icon/Planner/Play';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '@styles/index';

export const PlannerItemHeroIconSize = '40px';

export const ShadowPulse = keyframes`
  0% { box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    blur: Spacings.SPACING_0B,
    color: 'rgba(235,87,87, 0.4)'
  })}; }
  70% { box-shadow: ${boxShadowGenerator({
    yOffset: Spacings.SPACING_0B,
    blur: Spacings.SPACING_0B,
    spread: '10px',
    color: 'rgba(235,87,87, 0)'
  })}; }
  100% {
    box-shadow: none;
  }
`;

const StyledPlayIcon = styled(Play)`
  border-radius: 50%;
  ${({ $isLive }) =>
    $isLive &&
    css`
      animation: ${ShadowPulse} 1s infinite;
    `}
`;

const PlayIcon = ({
  color,
  isLive,
  isRecordingInProgress,
  className,
  iconSize
}) => (
  <StyledPlayIcon
    data-testid="planner-class-play-icon"
    size={iconSize || PlannerItemHeroIconSize}
    className={`${className} play-icon`}
    color={color}
    innerFillColor={
      isRecordingInProgress && !isLive ? 'var(--color-text-secondary)' : null
    }
    $isLive={isLive}
  />
);

export default PlayIcon;
